<div class="container-fluid">
  <div class="row">
    <div class="col-md-12 footer-copyright d-flex flex-wrap align-items-center justify-content-between">
      <p class="mb-0 f-w-600">Copyright 2023 © Eureka </p>
      <p class="mb-0 f-w-600">Made with Dotit srl</p>
    </div>
  </div>
</div>
